import { NewArrivals } from "../../Services/MainServices";

export const FETCH_TRENDING_REQUEST = "FETCH_TRENDING_REQUEST";
export const FETCH_TRENDING_SUCCESS = "FETCH_TRENDING_SUCCESS";
export const FETCH_TRENDING_FAILURE = "FETCH_TRENDING_FAILURE";

export const fetchTrendingThunk = () => async (dispatch) => {
  dispatch({ type: FETCH_TRENDING_REQUEST });
  try {
    const response = await NewArrivals();
    if (response.status === 200 && response.data?.data?.new_arrival_products) {
      // Slice the first 5 products
      const arrivals = response.data.data.new_arrival_products
      dispatch({
        type: FETCH_TRENDING_SUCCESS,
        payload: arrivals,
      });
    } else {
      dispatch({
        type: FETCH_TRENDING_FAILURE,
        payload: `Unexpected response: ${response.status}`,
      });
    }
  } catch (error) {
    dispatch({ type: FETCH_TRENDING_FAILURE, payload: error.message });
  }
};
